<template>
  <div class="docs-rich-text" v-html="safeContent"></div>
</template>

<script>
import { computed } from 'vue';
import { sanitizeHtml } from '../utils/sanitizeHtml';

export default {
  name: 'SafeHtml',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const safeContent = computed(() => sanitizeHtml(props.content));

    return { safeContent };
  }
};
</script>
